// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/wrapper/wrapper.scss
// module id = 535
// module chunks = 0